export default __webpack_public_path__ + "static/media/Lip_8_F.26392b93.svg";